import React, { Component } from 'react'
import { FormGroup, Label, Input, Col, FormText } from 'reactstrap';

import LoadingOption from './LoadingOption';

import ReactHtmlParser from 'react-html-parser';


import { CommaSeparateChip } from './CommaSeparateEmail';


import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import './formInput.css';

var moment = require('moment');


class DateComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: moment(),
            valueDate: props.value
        };
        this.handleChange = this.handleChange.bind(this);
    }


    componentDidMount() {
        if (this.state.valueDate !== '') {
            this.setState({
                startDate: moment(this.state.valueDate, 'YYYY-MM-DD')
            }, () => {
                this.props.changed({
                    target: {
                        value: this.state.valueDate
                    }
                })
            })
        } else {
            this.props.changed({
                target: {
                    value: moment().format('DD/MM/YYYY')
                }
            })
        }
    }

    handleChange(date) {

        this.setState({
            startDate: date
        }, () => {

            if (this.state.startDate !== null) {
                this.props.changed({
                    target: {
                        value: moment(this.state.startDate).format('DD/MM/YYYY')
                    }
                })
            } else {
                this.props.changed({
                    target: {
                        value: '___{Invalid}_@_{Date}___'
                    }
                })
            }
        });
    }

    render() {
        return (
            <DatePicker
                selected={this.state.startDate}
                onChange={this.handleChange}
                dateFormat="DD-MMM-YYYY"
                minDate={moment()}
                width={'100%'}
                className="pl-3 text-dark"
            />
        );
    }
}








const FormInput2 = (props) => {
    let inputElement = null;
    const inputClasses = [];

    if (props.invalid && props.shouldValidate && props.submitted) {
        inputClasses.push('invalid')
    }


    switch (props.type) {
        case ('commaSeparate'):
            inputElement = <div>
                <div>
                    {
                        props.commaSepareted !== null &&
                        <CommaSeparateChip changeErrorMessage={props.changeErrorMessage} commaSeparetedFunc={props.commaSeparetedFunc} />
                    }
                </div>
            </div>
            break;
        case ('disabledText'):
            inputElement = <div>
                <Input
                    className={inputClasses.join(' ')}
                    type={props.type}
                    name={props.name}
                    id={props.name}
                    placeholder={props.placeholder}
                    value={props.value}
                    onChange={props.changed}
                    disabled={'disabled'}
                /></div>
            break;
        case ('text'):
            inputElement =
                <Input
                    className={inputClasses.join(' ')}
                    type={props.type}
                    name={props.name}
                    id={props.name}
                    placeholder={props.placeholder}
                    value={props.value}
                    onChange={props.changed}
                />
            break;
        case ('pincodeText'):
            inputElement = <div>
                <Input
                    className={inputClasses.join(' ')}
                    type={'text'}
                    name={props.name}
                    id={props.name}
                    placeholder={props.placeholder}
                    value={props.value}
                    onChange={props.changed}
                    maxLength={"6"}
                /></div>
            break;
        case ('textarea'):
            inputElement =
                <Input
                    className={inputClasses.join(' ')}
                    type={props.type}
                    name={props.name}
                    id={props.name}
                    placeholder={props.placeholder}
                    value={props.value}
                    onChange={props.changed}
                />
            break;

        case ('hidden'):
            inputElement = <Input
                type={props.type}
                name={props.name}
                value={props.value}
                onMouseDown={() => {

                    if (props.value !== '') {
                        props.changed
                    }
                }}
            />
            break;

        case ('select'):
            inputElement =
                <LoadingOption
                    className={inputClasses.join(' ')}
                    type={props.type}
                    name={props.name}
                    id={props.name}
                    value={props.value}
                    onChange={props.changed}
                    value={props}
                    disableButtonFunc={(bool) => props.disableButtonFunc(bool)}
                    hardCodeSelects={props.hardCodeSelects}
                />
            break;
        case ('paraText'):
            inputElement = <p>{props.value}</p>
            break;
        case ('date'):
            inputElement = <DateComponent changed={props.changed} value={props.value} />

                ;
            break;
        case ('multiSelect'):
            inputElement = (
                <div>
                    {props.options.map((option) => (
                        <div key={option.id} className="custom-control custom-checkbox">
                            <input
                                type="checkbox"
                                className="custom-control-input"
                                id={`${props.name}-${option.id}`}
                                checked={props.value.includes(option.id)}
                                onChange={() => {
                                    const newValue = props.value.includes(option.id)
                                        ? props.value.filter(id => id !== option.id)
                                        : [...props.value, option.id];
                                    props.changed({ target: { name: props.name, value: newValue } });
                                }}
                            />
                            <label className="custom-control-label" htmlFor={`${props.name}-${option.id}`}>
                                {option.value}
                            </label>
                        </div>
                    ))}
                </div>
            );
            break;
        case ('number'):
            inputElement = <Input
                className={inputClasses.join(' ')}
                type={props.type}
                name={props.name}
                id={props.name}
                placeholder={props.placeholder}
                value={props.value}
                onChange={props.changed}
                onMouseDown={() => {
                    if (props.value !== '') {
                        props.changed;
                    }
                }}
                min={props.minValue}
                max={props.maxValue}
                onKeyPress={(event) => {
                    if (props.shouldValidate.onlyNumbers && !/^\d*$/.test(event.key)) {
                        event.preventDefault();
                    }
                }}
            />
            break;

        default:
            inputElement = <Input
                className={inputClasses.join(' ')}
                type={props.type}
                name={props.name}
                id={props.name}
                placeholder={props.placeholder}
                value={props.value}
                onChange={props.changed}
                onMouseDown={() => {
                    if (props.value !== '') {
                        props.changed
                    }
                }}
            />
    }

    return (
        <div>
            {
                (props.invalid && props.submitted) &&
                <p className="text-right text-danger mb-0 ">*{props.label}
                    &nbsp;{props.error}</p>
            }
            {

                (props.fieldError && !props.isFieldValid && !props.invalid) &&
                <div className="col-12">
                    <p className="text-right text-danger mb-0 ">*{props.label}
                        &nbsp;{props.fieldError}</p>

                </div>
            }
            <FormGroup row >
                {
                    props.name !== 'chooseFile' ?
                        <div style={{ display: 'flex', width: '100%' }}>
                            {
                                props.label &&
                                <Label className="h6 text-uppercase" for={props.name} sm={4} size="sm">{props.label}
                                    {
                                        props.required &&
                                        <span className="text-danger">*</span>
                                    }
                                </Label>
                            }
                            <Col className={props.label ? "pl-0" : "pl-3"} sm={props.label ? 8 : 12}>
                                {inputElement}
                                {ReactHtmlParser(props.textBelowInput)}
                            </Col>
                        </div>
                        :
                        <Col className="pl-2 pr-2" sm={12}>
                            <Input
                                className={inputClasses.join(' ')}
                                type={props.type}
                                name={props.name}
                                id={props.name}
                                placeholder={props.placeholder}
                                value={props.value}
                                accept={props.formElement.accept}
                                onChange={props.changed}
                                style={{ border: '1px solid' }}
                            />
                        </Col>
                }
            </FormGroup>
        </div>
    );
}

export default FormInput2;


// WEBPACK FOOTER //
// ./src/_components/common/Form2/formInput.jsx